export default __webpack_public_path__ + "static/media/Australian_Aboriginal_Flag.87e43d9c.svg";